import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import {
  INDY_PARTNERS_QUERY,
  LEGAL_FORMALITY_CONFIG_QUERY,
} from 'graphql/LegalFormalities'
import { Wrapper } from './styles'
import LegalFormalitySection, {
  LEGAL_FORMALITY_EMPTY,
  LegalFormalityValues,
} from './LegalFormalitySection'
import OrderParamsSection, {
  ORDER_PARAMS_EMPTY,
  OrderParamsValues,
} from './OrderParamsSection'

const Configs = (): JSX.Element => {
  const { legalFormality } = useContext(CurrentLegalFormalityContext)

  const { data: configData, refetch: refetchConfig } = useQuery(
    LEGAL_FORMALITY_CONFIG_QUERY,
    { variables: { id: legalFormality.id }, fetchPolicy: 'network-only' }
  )
  const { data: indyData } = useQuery(INDY_PARTNERS_QUERY)

  const config = configData?.legalFormality
  const id = parseInt(legalFormality.id)

  const lfInitial: LegalFormalityValues = config
    ? {
        domiciliationId: config.domiciliationId ?? '',
        depositProvider: config.depositProvider ?? '',
        noticeProvider:
          config.noticeProvider ?? config.legalNotice?.provider ?? '',
        signatureDate: config.signatureDate ?? '',
        signatureCity: config.signatureCity ?? '',
        capitalDepositDate: config.capitalDepositDate ?? '',
        capitalDepositCity: config.capitalDepositCity ?? '',
        finalLegalAuthorityId: config.finalLegalAuthorityId ?? '',
      }
    : LEGAL_FORMALITY_EMPTY

  const orderInitial: OrderParamsValues = config
    ? {
        partnerId: config.purchase?.partnerId ?? '',
        partnerCapitalDeposit: config.prospect?.partnerCapitalDeposit ?? '',
        taxOption: config.prospect?.taxOption ?? '',
        paidByPartner: config.prospect?.paidByPartner ?? '',
      }
    : ORDER_PARAMS_EMPTY

  return (
    <Wrapper>
      <LegalFormalitySection
        initialValues={lfInitial}
        legalFormalityId={id}
        onSaved={refetchConfig}
      />
      <OrderParamsSection
        initialValues={orderInitial}
        legalFormalityId={id}
        indyPartners={indyData?.indyPartners ?? []}
        onSaved={refetchConfig}
      />
    </Wrapper>
  )
}

export default Configs
